const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'https://api.neogtm.com' 
  : 'https://api.neogtm.com';

const ANALYTICS_DEBUG = import.meta.env.DEV;

async function logEvent(payload) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/analytics/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
      if (ANALYTICS_DEBUG) {
        console.error('Failed to log analytics event:', await response.text());
      }
    } else if (ANALYTICS_DEBUG) {
      console.debug('[analytics]', payload.event_type);
    }
  } catch (error) {
    if (ANALYTICS_DEBUG) {
      console.error('Error logging analytics event:', error);
    }
  }
}

export async function logBriefShown(params) {
  await logEvent({
    tenant_id: params.tenantId,
    user_id: params.userId,
    account_id: params.accountId,
    person_id: params.personId,
    event_type: 'brief_shown',
    source: params.source || 'brief',
    metadata: {
      ...params.metadata,
      brief_type: params.briefType,
      account_name: params.accountName,
    },
  });
}

export async function logNeoRecommendation(params) {
  await logEvent({
    tenant_id: params.tenantId,
    user_id: params.userId,
    account_id: params.accountId,
    person_id: params.personId,
    playbook_id: params.playbookId,
    event_type: 'neo_recommendation',
    source: params.source || 'chatbot',
    channel: params.channel,
    metadata: {
      ...params.metadata,
      recommendation_type: params.recommendationType,
      prompt_text: params.promptText,
      account_name: params.accountName,
      person_name: params.personName
    }
  });
}

export async function logAccountInteraction(params) {
  await logEvent({
    tenant_id: params.tenantId,
    user_id: params.userId,
    account_id: params.accountId,
    person_id: params.personId,
    playbook_id: params.playbookId,
    event_type: 'account_interaction',
    source: params.source || 'task_manager',
    channel: params.channel,
    metadata: {
      ...params.metadata,
      interaction_type: params.interactionType,
      exported: params.exported,
      touch_number: params.touchNumber,
      step_id: params.stepId,
      sequence_id: params.sequenceId,
      account_name: params.accountName,
      person_name: params.personName
    }
  });
}

export async function logTenderReviewed(params) {
  await logEvent({
    tenant_id: params.tenantId,
    user_id: params.userId,
    account_id: params.accountId,
    event_type: 'tender_reviewed',
    source: params.source || 'chatbot',
    metadata: {
      ...params.metadata,
      tender_id: params.tenderId,
      account_name: params.accountName
    }
  });
}

// Helper utilities
export function extractAccountId(account) {
  if (!account) return undefined;
  return account.account_id || account.id;
}

export function extractPersonId(person) {
  if (!person) return undefined;
  return person.person_id || person.id;
}

export function extractStepId(draft) {
  if (!draft) return undefined;
  return draft.stepId || draft.step_id || draft.id;
}

export function getCurrentTenantId(currentUser, fallback = 'instructure') {
  try {
    const adminTenant =
      currentUser?.role === 'admin'
        ? localStorage.getItem('admin-active-tenant')
        : null;
    if (adminTenant) return adminTenant;
  } catch (e) {
    // localStorage might not be available
  }
  return currentUser?.tenant_id || fallback;
}

export async function trackSalesMapAction({
  tenantId,
  userId,
  accountId,
  salesPoint,
  action,
}) {
  await logEvent({
    tenant_id: tenantId,
    user_id: userId,
    account_id: accountId,
    event_type: 'sales_map_action',
    metadata: {
      sales_point: salesPoint,
      action,
    },
  });
}